import {POObject} from './POObject';

export class POAbstractOrgUnit extends POObject {
  static virtualType = 'AbstractOrgUnit';

  path: string;
}
